<template>
  <div class="loader-wrapper">
    <div
      class="pulse-loader"
      :class="{ 'pulse-loader--small': title || subtitle }"
      aria-live="polite"
      aria-busy="true"
    >
      <div class="circle --top"></div>
      <div class="circle --bottom"></div>
    </div>
    <div class="text-wrapper" v-if="title || subtitle">
      <span v-if="title" class="t3 -t_semi-bold">{{ title }}</span>
      <span v-if="subtitle" class="t3">{{ subtitle }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PulseLoaderV2',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@ui-kit/styles/animations/_loader.scss";

.loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 1rem;

  .text-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
}

$outer-circle-size: 28px;
$outer-circle-size-small: 20px;
$inner-circle-size: 16px;
$space-between-circles: calc(#{$outer-circle-size - $inner-circle-size} / 2);
$animation-duration: 2.44s;

.pulse-loader {
  width: $outer-circle-size;
  height: 2.12 * $outer-circle-size;
  position: relative;

  .circle {
    width: $outer-circle-size;
    height: $outer-circle-size;
    position: absolute;
    animation-name: float;
    transform-origin: center center;
    animation-duration: $animation-duration;
    animation-iteration-count: infinite;
    transform: scale(0); // initially the circles shouldn't be visible

    &:before,
    &:after {
      content: "";
      position: absolute;
      border-radius: 50%;
      transform-origin: center center;
      animation-duration: $animation-duration;
      animation-iteration-count: infinite;
    }

    &:before {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: $color-negative-500;
      animation-name: shrink;
    }

    &:after {
      top: $space-between-circles;
      left: $space-between-circles;
      right: $space-between-circles;
      bottom: $space-between-circles;
      background-color: $background-color;
      animation-name: shrink-faster;
    }

    &.--bottom {
      animation-delay: calc(#{$animation-duration} / 2);

      &:before,
      &:after {
        animation-delay: calc(#{$animation-duration} / 2);
      }
    }
  }

  &--small {
    width: $outer-circle-size-small;
    height: 2.12 * $outer-circle-size-small;

    .circle {
      width: $outer-circle-size-small;
      height: $outer-circle-size-small;
    }
  }
}
</style>
